import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import SplitRows from '../../components/general/SplitRow.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import Notification from '../../components/Notification.js';
import Helmet from 'react-helmet';
import Switch from 'rc-switch';
import ColorPicker from "../../components/builder/ColorPicker";
import {setSetting} from '../../actions/General.js';
import moment from 'moment';
import LoadingSmall from "../../components/LoadingSmall";

class SettingsSync extends React.Component {
    constructor(props) {
        super(props);

        this.interval = null;

        this.state = {
            isLoading:true,
            syncing:false,
            last:false,
        }

    }


    componentWillMount() {
        this.checkStatus();

        this.interval = setInterval(() => {
            this.checkStatus();
        },5000)
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    checkStatus() {
        axios.get('/sync/status').then((result) => {
            this.setState({
                isLoading:false,
                last:result.data.last,
                syncing:result.data.status
            })
        });
    }

    getLastSyncDate = () => {
        return moment.utc(this.state.last).local().format('DD-MM-YYYY HH:mm:ss');
    }

    isRunning = () => {
        return this.state.syncing;
    }

    sync = () => {
        clearInterval(this.interval);

        axios.get('/sync/start').then((result) => {
            this.interval = setInterval(() => {
                this.checkStatus();
            },5000)

            this.setState({
                syncing:true,
            })
        });
    }

    getSyncMessage = () => {
        if(this.isRunning()) {
            return <span>We are currently syncing data. Please wait..</span>
        }

        if(!this.state.last) {
            return <span>We haven't run a sync yet.</span>
        }

        return <span>Last sync was done <strong>{this.getLastSyncDate()}.</strong></span>
    }

    render() {

        if(this.state.isLoading) {
            return <Loading error={false} />;
        }

        return (
            <div className="full-height">
                <Helmet title="Data sync | Crall.io" />
                <div className="page-header">
                    <span className="page-title"><i className="icon wb-code-working"></i> Data sync</span>
                </div>

                <div className="page-content">

                    <OptionColumn title="Manual sync" description="Force a manual sync of shop data">
                        <div className="col-sm-6 text-center">
                            {this.getSyncMessage()}
                        </div>
                        <div className="col-sm-6 text-center">
                            {
                                this.isRunning() ?
                                    <LoadingSmall />
                                    :
                                    <button onClick={this.sync} className="btn btn-dark">Start sync</button>
                            }
                        </div>
                    </OptionColumn>

                    <SplitRows />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setSetting},dispatch)
}


SettingsSync = connect(mapStateToProps,mapDispatchToProps)(SettingsSync);
export default SettingsSync;



// WEBPACK FOOTER //
// ./containers/settings/SettingsSync.js